/* eslint-disable no-console */
/*
 * @Author       : Zhelin Cheng
 * @Date         : 2021-11-08 15:12:33
 * @LastEditors  : 程哲林
 * @LastEditTime : 2024-04-09 19:39:56
 * @FilePath     : /marketing-introduce-ssr/pages/activity/[...slug].tsx
 * @Description  : 未添加文件描述
 */

import { Toast } from 'antd-mobile';
import cx from 'classnames';
import {
  ACT_TYPE_MAPS,
  envName,
  // AUTH_SIGN_URL,
  isBrowser,
  isJoJoUp,
  jojoAccountConfig,
  names,
  PLACEHOLDER_MAP,
  WX_JOJO_PARENTS_POSTER_PAGE
  // WEBSITE_URL,
} from 'common/const';
import Guidance, { NoviceGuidance } from 'components/Activity/Guidance';
import InviteFriends from 'components/Activity/InviteFriends';
import { TeamList, TeamPanel, TeamPanelShare, TourDetailType } from 'components/Activity/TeamComp';
import Cookies from 'js-cookie';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import { useRouter } from 'next/router';
import QS from 'querystring';
import qsString from 'querystring';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

import { platformList } from '@/common/const';
import { TINMAN_BASE_URL } from '@/common/const';
import { PAGE_LOADING_STOP } from '@/common/enums';
import PageProcess from '@/components/Activity/pageProgress';
import SignModal from '@/components/Activity/SignModal';
import TrialDirectPosterButton from '@/components/Activity/TrialDirectPosterButton';
import UserFeedback from '@/components/Activity/UserFeedback';
import PageLoading from '@/components/PageLoading';
import { getRetainRule } from '@/services';
import { userActionRecord } from '@/services';
import {
  getApolloConfig,
  getByActCode,
  getReserve,
  getWxConfig,
  queryGroupBookingOrderByGroupBookId,
  queryPackageWebPage,
  queryRecommendGiftGuidance,
  RecommendGiftGuidanceResp
  // userActionRecord,
} from '@/services/activity';
// import { getApi } from '@/utils/request'
import {
  getCurrPlatform,
  getEnvEnum,
  isWXAppBrowser,
  isWXBrowser,
  isWXMiniAppBrowser,
  qsParse,
  queryClear,
  reportError,
  urlAddObjQuery
} from '@/utils';
import { CALLBACK_URL, labelName, openLinkByMiniWay } from '@/utils/activity';
import bus from '@/utils/bus';
import {
  getCanShareToastText,
  getStatusTipsText,
  isRenewalReferralActivity,
  shouldShowRenewalStatusTips
} from '@/utils/renewalReferral';
import { saveSensData, sensAutoTrack, sensClickInitiative, sensElementView } from '@/utils/sensors';

import GiftIcon from '../../assets/activity/img56.png';
import styles from './index.module.scss';

async function bindRelation() {
  try {
    const query = qsParse();
    const inviteCode = query.inviteCode || query.invite;

    if (!inviteCode) {
      return;
    }

    if (localStorage.getItem(inviteCode.toString())) {
      return;
    }

    // iftw_z1d1

    const p = await getCurrPlatform();

    const request = new XMLHttpRequest();
    request.withCredentials = true;
    request.open('POST', `${TINMAN_BASE_URL}/api/boom/fe/event/scanActivityCode`, true);
    request.setRequestHeader('Content-Type', 'application/json');

    request.send(
      JSON.stringify({
        inviteCode,
        userPlatform: p,
        channel: query.channel,
        channelNo: query.channelNo,
        orderSource: query.orderSource || '',
        appId: query.appId || ''
      }) as any
    );

    request.onload = () => {
      if (request.status >= 200 && request.status < 400) {
        // Success!
        const data = JSON.parse(request.response);

        if (data?.status !== 1001) {
          localStorage.setItem(inviteCode.toString(), '1');
        }
      }
    };
  } catch (e) {
    console.error(e);
  }
}

function offset(el: Element) {
  if (!el) {
    return { top: 0, left: 0 };
  }

  const box = el.getBoundingClientRect();
  const docElem = document.documentElement;
  return {
    top: box.top + window.pageYOffset - docElem.clientTop,
    left: box.left + window.pageXOffset - docElem.clientLeft
  };
}

const {
  Timer,
  ImageGroup,
  PosterCom,
  SignIn,
  Upload,
  Swiper,
  ShopModule,
  InvitedProgress,
  TasksComp,
  TipsPopup,
  Abnormal,
  Buoy,
  ReserveButton,
  SignButton,
  LotteryBox,
  AppDialog,
  VideoCom,
  ChangeUser,
  LotteryCount,
  PointLotteryBtn,
  PointCom,
  PointExpireComponent,
  Carousel,
  ReserveTime,
  DescriptionPopup,
  RecommendGift,
  InviteFriendsV2,
  CourseCompletionProgress
} = {
  ChangeUser: dynamic<any>(() => import('../../components/Activity/ChangeUser'), {
    ssr: false
  }),
  VideoCom: dynamic<any>(() => import('../../components/Activity/VideoCom'), {
    ssr: false
  }),
  ImageGroup: dynamic<any>(() => import('../../components/Activity/ImageGroup'), {
    ssr: false
  }),
  Timer: dynamic<any>(() => import('../../components/Activity/Timer'), {
    ssr: false
  }),
  PosterCom: dynamic<any>(() => import('../../components/Activity/PosterCom'), {
    ssr: false
  }),
  SignIn: dynamic<any>(() => import('../../components/Activity/SignIn'), {
    ssr: false
  }),
  LotteryBox: dynamic<any>(() => import('../../components/Activity/LotteryBox'), {
    ssr: false
  }),
  ReserveButton: dynamic<any>(
    () => import('../../components/Activity/ReserveButton').then((mod) => mod.ReserveButton),
    {
      ssr: false
    }
  ),
  SignButton: dynamic<any>(() => import('../../components/Activity/SignButton'), {
    ssr: false
  }),
  PointLotteryBtn: dynamic<any>(() => import('../../components/Activity/PointLotteryBtn'), {
    ssr: false
  }),
  Buoy: dynamic<any>(() => import('../../components/Activity/Buoy').then((mod) => mod.Buoy), {
    ssr: false
  }),
  Abnormal: dynamic<any>(
    () => import('../../components/Activity/Abnormal').then((mod) => mod.Abnormal),
    {
      ssr: false
    }
  ),
  InvitedProgress: dynamic<any>(
    () => import('../../components/Activity/InvitedProgress').then((mod) => mod.InvitedProgress),
    {
      ssr: false
    }
  ),
  ShopModule: dynamic<any>(
    () => import('../../components/Activity/ShopModule').then((mod) => mod.ShopModule),
    {
      ssr: false
    }
  ),
  RecommendGift: dynamic<any>(
    () => import('../../components/Activity/RecommendGift').then((mod) => mod.RecommendGift),
    {
      ssr: false
    }
  ),
  TasksComp: dynamic<any>(
    () => import('../../components/Activity/Tasks').then((mod) => mod.TasksComp),
    {
      ssr: false
    }
  ),
  TipsPopup: dynamic<any>(
    () => import('../../components/Activity/TipsPopup').then((mod) => mod.TipsPopup),
    {
      ssr: false
    }
  ),
  Upload: dynamic<any>(() => import('../../components/Activity/Upload').then((mod) => mod.Upload), {
    ssr: false
  }),
  Swiper: dynamic<any>(() => import('../../components/Activity/Swiper').then((mod) => mod.Swiper), {
    ssr: false
  }),
  AppDialog: dynamic<any>(
    () => import('../../components/RetainDialog').then((mod) => mod.AppDialog),
    {
      ssr: false
    }
  ),
  LotteryCount: dynamic<any>(() => import('../../components/Activity/LotteryCount'), {
    ssr: false
  }),
  PointCom: dynamic<any>(() => import('../../components/Activity/Point'), {
    ssr: false
  }),
  PointExpireComponent: dynamic<any>(() => import('../../components/Activity/PointExpire'), {
    ssr: false
  }),
  Carousel: dynamic<any>(
    () => import('../../components/Activity/Carousel').then((mod) => mod.Carousel),
    {
      ssr: false
    }
  ),
  ReserveTime: dynamic<any>(
    () => import('../../components/Activity/ReserveTime').then((mod) => mod.ReserveTime),
    {
      ssr: false
    }
  ),
  DescriptionPopup: dynamic<any>(() => import('../../components/Activity/DescriptionPopup'), {
    ssr: false
  }),
  InviteFriendsV2: dynamic<any>(() => import('../../components/Activity/InviteFriendsV2'), {
    ssr: false
  }),
  CourseCompletionProgress: dynamic<any>(
    () =>
      import('../../components/Activity/CourseCompletionProgress').then(
        (mod) => mod.CourseCompletionProgress
      ),
    {
      ssr: false
    }
  )
};

interface ActivityGuideFlowConfigs {
  id: string;
  guideType: string;
  guideSubject: string;
  guideRole: string;
  followed: boolean;
  data: {
    guideFlowQrCode: string;
  };
}

interface ActInfo {
  id: string;
  showScore: boolean;
  mallShopUrl: string;
  userAvatar: string;
  userId: string;
  userHalfMobile: string;
  userNickname: string;
  activityName: string;
  actCode: string;
  timingType: string;
  activityStatus: string;
  startTime: number;
  endTime: number;
  includedCurrentUser: boolean;
  webPageId: string;
  defaultActivityId: string;
  defaultActivityUrl: string;
  title: string;
  activityType: string;
  posters: any[];
  riskUser: string;
  shared: boolean;
  activityGuideFlowConfigs: ActivityGuideFlowConfigs[];
  noCourse: boolean;
  avatar: string;
  nickname: string;
  prizeUserCount: number;
  prizeMaxLimit: number;
  posterFlowGrayscale: string;
  personType: 'INITIATIVE' | 'PASSIVE';
  teams: {
    avatar: string;
    nickname: string;
  }[];
  jumpAppActUrl: string;
  banduNewUser: boolean;
  banduYearCourseUser: boolean;
  parentAvatar: string;
  parentNickname: string;
  reserved: boolean;
  limitText: string;
  limitButtonText: string;
  limitRedirectUrl: string;
  sceneLabel: string;
  showNoviceGuidance: boolean;
  noviceGuidanceInfo: NoviceGuidance;
  shareInfo: {
    sharePostImg: string;
    shareDesc: string;
    shareTitle: string;
    shareImage: string;
  };
  obtainLotteryCountText?: string;
  guideShareText: string;
}

type ReserveType = {
  activityId: string;
  countdown: string;
  endTime: number;
  isReserve: boolean;
  openMaxPrice: number;
  openMinPrice: number;
  openTime: number;
  productId: string;
  reservePerson: number;
  startTime: number;
  status: string;
  teacherId?: any;
  userReserved: boolean;
  classPeriod?: boolean;
  whiteListUser: boolean;
  teacherNickName: string;
  userReservedJumpUrl: string;
  goodsSaleEndTime?: string;
};
const namesArr = names
  .sort(() => {
    return Math.random() - 0.5;
  })
  .slice(0, 10);

interface SensorsClickEvent {
  onSensors?: (e?: React.UIEvent) => void;
}

const isWx = isWXBrowser();

const isJoJoReadApp = (() => {
  if (!isBrowser) {
    return false;
  }

  const ua = window.navigator.userAgent;
  return /JoJoAppFrom\/read/gim.test(ua);
})();

export const isParentTerminalMiniProgram = () => {
  const ua = window?.navigator?.userAgent;
  const textStr =
    envName === 'pro' ? 'miniProgram/wx21ae2ebd76fa1ef6' : 'miniProgram/wx6937868d2c47cac1';
  return new RegExp(textStr).test(ua);
};

const ImgComp = React.memo(
  ({
    href,
    src = '',
    onSensors,
    style,
    reloadType,
    dataLogin
  }: {
    href?: string;
    src: string;
    reloadType?: string;
    style?: Record<string, string | undefined>;
    dataLogin?: 0;
  } & SensorsClickEvent) => {
    /* const ua = window.navigator.userAgent
  if (/JoJoAppFrom\/read/gim.test(ua)) {
    // 叫叫APP
    return 0
  } */

    const currLink = useMemo(() => {
      if (!isJoJoReadApp || !href || !/^http/.test(href)) {
        return href;
      }

      if (isJoJoReadApp && reloadType !== 'APP') {
        return `tinman-router://cn.tinman.jojoread/webview?url=${encodeURIComponent(href)}`;
      } else {
        return href;
      }
    }, [href]);

    const isPosterBtn = reloadType === 'GENERATE_POSTER' ? 1 : 0;

    return href ? (
      <a
        style={style}
        onClick={onSensors}
        href={currLink}
        className={styles['cp-img']}
        data-login={dataLogin}
        data-reloadType={reloadType}>
        <img
          className='lazyload'
          src={PLACEHOLDER_MAP}
          data-src={src}
          alt=''
          data-isPoster={isPosterBtn}
        />
      </a>
    ) : (
      <div style={style} onClick={onSensors} className={styles['cp-img']}>
        <img className='lazyload' src={PLACEHOLDER_MAP} data-src={src} alt='' />
      </div>
    );
  }
);

function getTeamStatus(sd: number, ed: number): number {
  const nowTime = Date.now();
  const isStart = nowTime - sd > 0;
  const isEnd = nowTime - ed > 0;

  if (!isStart) {
    return 0;
  }

  if (isStart && !isEnd) {
    return 1;
  }

  return 2;
}

const ButtonComp = React.memo(
  ({
    href,
    src = '',
    isBottom,
    onSensors,
    reloadType,
    style = {},
    isNeedJumpToMiniProgram = false
  }: {
    isBottom: boolean;
    href?: string;
    src: string;
    reloadType: string;
    style?: Record<string, any>;
    isNeedJumpToMiniProgram: boolean;
  } & SensorsClickEvent) => {
    const newStyle = useMemo(() => {
      if (!style?.width) {
        return {};
      }

      const width = parseInt(style.width, 10);
      const height = parseInt(style.height, 10);

      const isTwo = width > 375;

      return {
        width: `${(isTwo ? width : width * 2) / 100}rem`,
        height: `${(isTwo ? height : height * 2) / 100}rem`
      };
    }, [style]);

    let newHref = href;

    if (reloadType === 'APP') {
      const jumpToDown = 'https://jojoread.tinman.cn/user/deeplink-pro';
      newHref = isJoJoReadApp ? href : jumpToDown;
    }

    if (
      reloadType === 'GENERATE_POSTER' &&
      isParentTerminalMiniProgram() &&
      isNeedJumpToMiniProgram
    ) {
      newHref = '';
    }

    useEffect(() => {
      if (__store.sceneParams?.scene === 'BtnClick') {
        if (reloadType === __store.sceneParams?.btnReloadType) {
          __store.sceneParams = null;
          onSensors?.();
          if (newHref?.length) {
            window.location.href = newHref;
          } else {
            bus.emit(PAGE_LOADING_STOP);
          }
        }
      }
    }, [reloadType, newHref]);

    if (isBottom) {
      return (
        <a
          id='j-cp-btn'
          onClick={onSensors}
          href={newHref}
          style={{
            backgroundImage: `url(${src})`,
            ...newStyle
          }}
          data-reloadType={reloadType}
          className={styles['cp-btn']}>
          <span />
        </a>
      );
    } else {
      return (
        <ImgComp
          style={newStyle}
          reloadType={reloadType}
          onSensors={onSensors}
          href={newHref}
          src={src}
        />
      );
    }
  }
);

// const isJojo = isJoJoBrowser() || isWXBrowser()
// 神策上报信息
const sensInfo: any = {
  activity_label: '',
  material_custom: '',
  $utm_content: '',
  material_ids: [],
  sku_id: '',
  activity_id: ''
};

const defaultWxAppId = () => {
  if (envName !== 'pro') {
    return 'wx6bc1e63a0998b3b7';
  }
  return !isJoJoUp ? 'wx20de7a2d28226c8f' : 'wx6050d5e375a41bc0';
};

export function wxShare({
  wechatAppId = '',
  shareTitle = '',
  shareDesc = '',
  shareImage = '',
  openMiniApp = false
}) {
  try {
    const pass = !(isBrowser && isWx && shareTitle);
    const miniApp = isWXMiniAppBrowser();

    if (miniApp) {
      const miniShareInfo = {
        // 小程序分享第一个字符被截取，导致shareTitle有问题，这里添加一个t占位
        t: '1',
        shareTitle: shareTitle || document.title || '',
        shareUrl: encodeURIComponent(window.location.href || ''),
        shareImage: shareImage || ''
      };
      window.history.replaceState(
        {},
        document.title,
        urlAddObjQuery(window.location.href, miniShareInfo)
      );
    }

    if (pass || miniApp) {
      return;
    }

    const { wx } = window;

    if (!wx) {
      return;
    }

    const { href } = window.location;

    const currLink = openMiniApp
      ? `https://act.tinman.cn/transform?jumpUrl=${encodeURIComponent(href)}`
      : href;

    const appId = wechatAppId || defaultWxAppId();

    getWxConfig({
      appId,
      url: currLink
    }).then((res: any) => {
      if (res.resultCode === 200) {
        wx.config({
          debug: false,
          ...res.data,
          jsApiList: [
            'onMenuShareAppMessage',
            'onMenuShareTimeline',
            'updateAppMessageShareData',
            'updateTimelineShareData',
            'showMenuItems',
            'hideMenuItems'
          ]
        });

        const sharePic = /^http/.test(shareImage) ? shareImage : `https:${shareImage}`;
        // 微信分享
        wx.ready(() => {
          wx.updateAppMessageShareData({
            title: shareTitle, // 分享标题
            desc: shareDesc, // 分享描述
            link: currLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: sharePic // 分享图标
            // success: function () {},
          });

          wx.updateTimelineShareData({
            title: shareTitle, // 分享标题
            link: currLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: sharePic // 分享图标
            // success: function () {},
          });
        });
      }
    });
  } catch (e) {
    reportError(e);
  }
}

const z1d1 = ['iftw_z1d1', 'iftw_xsz1d4', 'iftw_zdqxk'];

// 用户是否可以参团
let userIsCanJoinGroup = true;
if (isBrowser) {
  if (window?.jojoAccount) {
    jojoAccount?.config(jojoAccountConfig);
  }
}

function autoRedirectProductPage(reserve: ReserveType) {
  const nowTime = Date.now();
  const { openTime, startTime, userReserved, goodsSaleEndTime, endTime }: ReserveType = reserve;
  const saleTime = openTime || endTime;
  if (userReserved) {
    if (saleTime > nowTime) {
      // 开售时间大于当前时间=>已预约待开售
      return false;
    }
  }

  if (nowTime < startTime) {
    // 未开始
    return false;
  }

  if (nowTime > startTime && saleTime > nowTime) {
    // 预约中
    return false;
  }

  if (openTime) {
    if (goodsSaleEndTime && Number(goodsSaleEndTime) < nowTime) {
      return false;
    } else {
      return true;
    }
  } else {
    if (saleTime < nowTime && !userReserved) {
      return false;
    }
    return true;
  }
}

const ActivityPage = React.memo((): JSX.Element => {
  const [pageData, setPageData] = useState<{
    loading: boolean;
    actInfo: ActInfo;
    components: any[];
    error: boolean | string;
    invite: any;
    reserve?: ReserveType;
    posterSharingButtonIndex?: number;
    recordUserVisitTask?: string;
    userVisitDuration?: number;
    hasPosterComponent: boolean;
    isNeedJumpToMiniProgram: boolean;
  }>({
    loading: true,
    components: [],
    error: false,
    actInfo: {
      id: '',
      activityType: '',
      showScore: false,
      activityName: '',
      mallShopUrl: '',
      actCode: '',
      timingType: '',
      activityStatus: '',
      startTime: 0,
      endTime: 0,
      reserved: false,
      includedCurrentUser: true,
      webPageId: '',
      defaultActivityId: '',
      defaultActivityUrl: '',
      title: '',
      posters: [],
      riskUser: '',
      shared: false,
      activityGuideFlowConfigs: [],
      noCourse: false,
      avatar: '',
      nickname: '',
      prizeUserCount: 0,
      prizeMaxLimit: 0,
      personType: 'PASSIVE',
      parentAvatar: '',
      parentNickname: '',
      limitText: '',
      limitButtonText: '',
      limitRedirectUrl: '',
      teams: [],
      jumpAppActUrl: '',
      banduNewUser: false,
      banduYearCourseUser: false,
      posterFlowGrayscale: '',
      sceneLabel: '',
      userAvatar: '',
      userId: '',
      userHalfMobile: '',
      userNickname: '',
      shareInfo: {
        sharePostImg: '',
        shareDesc: '',
        shareTitle: '',
        shareImage: ''
      },
      showNoviceGuidance: false,
      noviceGuidanceInfo: {
        componentId: null,
        componentType: 'NOVICE_GUIDANCE',
        sortNum: null,
        data: {
          fileCover: '',
          showType: 'first',
          newbieGuideFile: '',
          showWidth: 300
        },
        componentName: ''
      },
      guideShareText: ''
    },
    hasPosterComponent: false,
    isNeedJumpToMiniProgram: false,
    invite: {}
  });

  const [retainRuleData, setRetainRuleData] = useState<null | RetainRuleData>(null);

  // 提醒显示弹窗
  const [showTipsPopup, setShowTipsPopup] = useState<boolean>(false);

  // 推荐礼待领奖弹窗（页面级统一管理，仅 xuedou 场景生效）
  const [giftModalVisible, setGiftModalVisible] = useState(false);
  const [giftGuidanceData, setGiftGuidanceData] = useState<RecommendGiftGuidanceResp | null>(null);

  // 蒙层loading
  const [maskPageLoading, setMaskPageLoading] = useState(true);

  const timerRef = useRef<any>();

  const componentsRef = useRef<any[]>([]);
  const router = useRouter();

  const { query } = router;
  const { actInfo } = pageData;
  componentsRef.current = pageData.components;
  const shareId = queryClear(query.teamId);
  const teacherId = queryClear(query.teacherId);
  const channelNo = queryClear(query.channelNo);
  const needSaveVisit = queryClear(query.needSaveVisit);
  const duration = queryClear(query.duration);

  const ButtonShareRef = React.createRef<any>();
  const bottomStatus = useRef(false);

  const channelStr = Array.isArray(query.channel) ? query.channel[0] : query.channel;

  const noPublicInvite = useMemo(() => {
    return actInfo.personType === 'PASSIVE';
  }, [actInfo.personType]);

  useEffect(() => {
    const { search } = window.location;
    if (!pageData.loading && /iqr=1/gim.test(search)) {
      ButtonShareRef.current.change(5);
    }
  }, [ButtonShareRef, pageData.loading]);

  useEffect(() => {
    const init = async (ev?: any) => {
      if (document.visibilityState === 'hidden') {
        return;
      }

      const { slug = [], orderSource, shopId = '' } = (router.query as any) || {};
      Cookies.set('orderSource', orderSource || '', { expires: 1 });
      Cookies.set('shopId', shopId || '', { expires: 1 });

      if (slug.length < 2) {
        return;
      }

      const hash = slug[0];
      const actCode = slug[1];
      const webPageId = slug[2];
      const qs = qsParse();
      const actCodeQuery = {
        actCode,
        inviteCode: qs.invite || '',
        channel: channelStr,
        channelNo,
        teamId: shareId,
        isSaveVisitAction: false
      };

      const confRes = await getByActCode<ActInfo>(actCodeQuery, Boolean(ev));

      if (webPageId) {
        const urlParams = qsParse();
        const { scene, groupBookingId, scenePId, pShareType, sceneTId, btnReloadType, ...rest } =
          urlParams;
        if (scene?.length) {
          if (scene?.length) {
            __store.sceneParams = {
              scene,
              groupBookingId,
              scenePId,
              pShareType,
              sceneTId,
              btnReloadType
            };
          }

          const _url = Object.keys(rest)?.length
            ? [
                window.location.origin,
                window.location.pathname,
                '?',
                QS.stringify({ ...rest })
              ].join('')
            : `${window.location.origin}${window.location.pathname}`;

          window.history.replaceState({}, '', _url);
        }
        __store.actPageIndex = true;

        let shareInfo = {
          wechatAppId: '',
          shareTitle: '',
          shareDesc: '',
          shareImage: ''
        };
        // @ts-ignore
        const typeId = parseInt(/_(?<type>\d+)/.exec(hash)?.groups?.type || '100', 10);

        const typeName = ACT_TYPE_MAPS[typeId] || localStorage.getItem('activityType');
        if (isWXAppBrowser() || isJoJoReadApp) {
          if (['RESERVE', 'GROUP', 'LOTTERY'].includes(typeName as string) || shareId) {
            try {
              const apolloConfigRes = await getApolloConfig({
                key: 'lowcode.operation_activity.shunt'
              });
              const { data }: any = apolloConfigRes;
              if (data?.length) {
                const type = typeName || (shareId ? 'GROUP' : '');
                const config = JSON.parse(data);
                const { lowcodeUrl, shuntRate, actCode: configActCode } = config[type];
                const rate = Math.random();
                if (actCode === configActCode && lowcodeUrl && rate < shuntRate) {
                  window.location.replace(
                    `${lowcodeUrl}?${QS.stringify({
                      webPageId,
                      actCode,
                      teamId: shareId,
                      teacherId
                    })}`
                  );
                  return;
                }
              }
            } catch (error) {
              console.log(error);
            }
          }
        }
        let activityList: any = JSON.stringify([]);
        if (!isJoJoUp) {
          const configRes = await getApolloConfig({
            key: 'boom.activity.poster.share.miniApp'
          });
          activityList = configRes?.data || JSON.stringify([]);
        }

        const _t = Date.now();

        const initReqs: any[] = [
          confRes,
          queryPackageWebPage<any[]>({
            webPageId,
            teacherId,
            activityCode: actCode,
            _t
          })
        ];

        // 拼团
        if (typeName === 'GROUP' || shareId) {
          initReqs.push(queryGroupBookingOrderByGroupBookId({ groupBookId: shareId }));
        } else {
          initReqs.push(undefined);
        }

        // 预约
        if (typeName === 'RESERVE' || typeName === undefined) {
          initReqs.push(
            getReserve({
              actCode,
              teacherId: qs.teacherId || ''
            })
          );
        }

        Promise.all(initReqs)
          .then(([conf, comps, invite = {}, reserve = {}]: any[]) => {
            if (comps.code !== 'SUCCESS') {
              return;
            }

            __store.actInfo = conf?.data || {};

            // 漏洞修复，如果用户参加坚持学，没有走特殊定制链接，直接重定向
            const sceneLabel = conf?.data?.sceneLabel;
            if (['PERSIST_IN_STOCK_IN', 'PICI_WEEKLY'].includes(sceneLabel)) {
              const code = conf?.data?.actCode || '';
              const sceneUrlParam = qsParse();

              router.replace(
                `/studyCheckIn?${qsString.stringify({
                  actCode: code,
                  ...sceneUrlParam
                })}`
              );
              return;
            }
            if (['PICI_WEEKLY_V2'].includes(sceneLabel)) {
              const code = conf?.data?.actCode || '';
              const sceneUrlParam = qsParse();

              router.replace(
                `/studyCheckInV2?${qsString.stringify({
                  actCode: code,
                  ...sceneUrlParam
                })}`
              );
              return;
            }
            if (['PICI_WEEKLY_V3'].includes(sceneLabel)) {
              const code = conf?.data?.actCode || '';
              const sceneUrlParam = qsParse();

              router.replace(
                `/studyCheckInV3?${qsString.stringify({
                  actCode: code,
                  ...sceneUrlParam
                })}`
              );
              return;
            }
            if (['ZZFX_V2'].includes(sceneLabel)) {
              const code = conf?.data?.actCode || '';
              const sceneUrlParam = qsParse();
              router.replace(
                `/weeklyShareV2?${qsString.stringify({
                  actCode: code,
                  ...sceneUrlParam
                })}`
              );
              return;
            }

            __store.topic_name = labelName(__store.actInfo?.sceneLabel);
            Cookies.set(`s-teacherId-${conf?.data?.id}`, teacherId || '');

            const userGroupOrder = invite?.data?.userGroupOrder || {};
            const { groupBookingOrderId } = userGroupOrder || {};
            const prdId = userGroupOrder?.preOrderId;
            const groupOrderStatus = userGroupOrder?.groupOrderStatus;
            if (prdId) {
              const { channel } = query;
              if (groupOrderStatus === 'WAIT_PAY') {
                router.replace(`/activity/team/mine?${qsString.stringify({ channel, channelNo })}`);
              } else {
                router.replace(
                  `/activity/team?${qsString.stringify({
                    preId: prdId === '0' ? undefined : prdId,
                    channel,
                    channelNo,
                    groupOrderId: groupBookingOrderId
                  })}`
                );
              }
              return;
            }

            const apiActInfo = conf.data;

            shareInfo = apiActInfo?.shareInfo || {};
            sessionStorage.setItem('actInfo', JSON.stringify(apiActInfo));
            let hasPosterComponent = false;
            // 组件数据筛选
            const compsItems = comps.data.filter((item: any) => {
              if (item?.componentType === 'COLLAGE') {
                userIsCanJoinGroup = Boolean(item?.isCanJoinGroup);
              }
              if (item?.componentType === 'POSTER_GROUP') {
                hasPosterComponent = true;
              }

              return item;
            });

            // 商品SKUID
            const store = compsItems.find(({ componentType, commonExtVo = {} }: any) => {
              if (
                componentType === 'BUTTON' &&
                commonExtVo.reloadType !== 'INVITE_FRIENDS_TO_WIN' &&
                commonExtVo.isBottom
              ) {
                bottomStatus.current = true;
              }

              return componentType === 'MALL_STORE';
            });

            const posterSharingButtonIndex = compsItems.findIndex(
              ({ commonExtVo, componentType }: any) => {
                return componentType === 'BUTTON' && commonExtVo.reloadType === 'REFERRAL_UPLOAD';
              }
            );

            if (store) {
              sensInfo.goods_id =
                store?.shopProductVos?.map(({ productId }: any) => productId).join(',') || '';
              sensInfo.sku_id = store?.skuIds?.join(',') || '';
            }
            // 活动ID
            const actId = apiActInfo.id;
            // 活动ID
            sensInfo.activity_id = actId;
            // 活动页ID
            sensInfo.material_ids = webPageId ? [webPageId.toString()] : [];
            // 场景标签
            sensInfo.topic_name = labelName(apiActInfo.sceneLabel);

            // 规则ID
            const task = compsItems?.find(({ componentType }: any) => {
              return componentType === 'TASK';
            });
            if (task) {
              sensInfo.material_custom = task?.commonExtVo?.taskContents
                ?.map(({ ruleId }: any) => ruleId)
                ?.join(',');
            }

            // 海报ID
            if (Array.isArray(apiActInfo.posters)) {
              let posterArr: string[] = [];
              conf.data.posters.forEach(({ activityPosterTabs }: any) => {
                activityPosterTabs.forEach(({ posterIds }: any) => {
                  posterArr = posterArr.concat(posterIds);
                });
              });
              sensInfo.$utm_content = posterArr.join(',');
            }

            // 活动类型
            sensInfo.activity_label = apiActInfo.activityType || '';

            /* compsItems.map(({ componentType, isCanJoinGroup }: any) => {
            if (componentType === 'COLLAGE') {
              userIsCanJoinGroup = Boolean(isCanJoinGroup)
            }
          }) */

            // 获取是否配置了挽留
            const retainRuleId = conf?.data?.extraData?.webPageRetainPopupId;
            if (retainRuleId) {
              getRetainRule({ id: retainRuleId }).then((ruleRes: any) => {
                const { data: ruleData } = ruleRes;
                if (ruleData) {
                  setRetainRuleData({
                    ...ruleData,
                    activityId: conf?.data?.id,
                    material_ids: sensInfo.material_ids
                  });
                }
              });
            }
            let isNeedJumpToMiniProgram = false;
            if (Array.isArray(JSON.parse(activityList as any))) {
              isNeedJumpToMiniProgram = JSON.parse(activityList as any).includes(Number(actId));
            }
            sessionStorage.setItem(
              'isNeedJumpToMiniProgram',
              JSON.stringify(isNeedJumpToMiniProgram)
            );

            if (reserve?.data) {
              const canIGotoProductPage = autoRedirectProductPage(reserve?.data);
              if (canIGotoProductPage && reserve?.data?.productId && __store.isLogin) {
                window.location.replace(
                  reserve?.data?.userReservedJumpUrl
                    ? `${reserve?.data?.userReservedJumpUrl}&activityId=${actId}`
                    : ''
                );
                return;
              }
            }
            setMaskPageLoading(!!scene?.length);
            setPageData((ct: any) => {
              return {
                ...ct,
                posterSharingButtonIndex,
                loading: false,
                actInfo: apiActInfo,
                reserve: reserve.data,
                components: [...compsItems],
                recordUserVisitTask: conf?.data?.recordUserVisitTask,
                userVisitDuration: conf?.data?.userVisitDuration,
                hasPosterComponent,
                isNeedJumpToMiniProgram,
                invite: invite?.data
              };
            });

            // 抽奖活动的异常提示， 活动状态/范围用户；续费转介绍活动未开始/已结束改为可关闭弹窗提示
            setShowTipsPopup(
              (['LOTTERY', 'GENERAL_TASK_ACTIVITY'].includes(apiActInfo.activityType) &&
                (!['PROCESSING'].includes(apiActInfo.activityStatus) ||
                  !apiActInfo.includedCurrentUser)) ||
                shouldShowRenewalStatusTips(apiActInfo)
            );

            // 赠1得1绑定关系
            if (z1d1.includes(conf?.data?.sceneLabel)) {
              bindRelation();
            }
          })
          .catch((e) => {
            reportError(e);
          })
          .finally(() => {
            saveSensData(sensInfo);
            sensAutoTrack({
              ...sensInfo,
              $title: '运营活动活动页'
            });

            userActionRecord({
              actionType: '浏览',
              actionContent: '运营活动落地页',
              data: {
                activityId: __store?.actInfo?.id,
                channel: channelStr,
                channelNo
              },
              url: window.location.href,
              userType: 'INITIATIVE',
              sceneType: __store?.actInfo?.activityType
            });
            if (!qs?.shareUrl) {
              // 微信分享调用
              wxShare(shareInfo);
            }
          });
      } else {
        const { code, data } = confRes;

        if (code !== 'SUCCESS') {
          setPageData((ct) => {
            return {
              ...ct,
              error: true
            };
          });
        } else {
          const { pathname, search } = window.location;

          __store.actInfo = data;
          localStorage.setItem('activityType', data?.activityType || '');

          if (data) {
            if (actCode === data.actCode) {
              router.replace(`${pathname}/${data.webPageId}${search}`);
            } else {
              router.replace(
                `${pathname.replace(/\/([^/]+)$/, '')}/${data.actCode}/${data.webPageId}${search}`
              );
            }
          } else {
            setPageData((ct) => {
              return {
                ...ct,
                error: '页面已被删除'
              };
            });
          }
        }
      }
    };
    init();

    document.addEventListener('visibilitychange', init);
    return () => {
      __store.actPageIndex = false;
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      document.removeEventListener('visibilitychange', init);
    };
  }, [channelStr, router, shareId, teacherId]);

  useEffect(() => {
    const event = () => {
      setMaskPageLoading(false);
    };

    bus.on(PAGE_LOADING_STOP, event);

    return () => {
      bus.off(PAGE_LOADING_STOP, event);
    };
  }, []);

  // 推荐礼待领奖弹窗：仅 App 内、已登录、且活动类型为转介绍时调用引导接口
  useEffect(() => {
    if (pageData.loading || !actInfo.id) {
      return;
    }
    // 非 App 内、未登录、或非转介绍活动时不查询，静默跳过
    if (!isJoJoReadApp || !__store.isLogin || actInfo.activityType !== 'REFERRAL') {
      return;
    }
    queryRecommendGiftGuidance<RecommendGiftGuidanceResp>({ activityId: actInfo.id })
      .then((res) => {
        if (res?.code === 'SUCCESS' && res?.data?.hasPendingReward) {
          setGiftGuidanceData(res.data);
          setGiftModalVisible(true);
          sensElementView({
            c_element_name: '运营活动活动页_领推荐礼弹窗',
            channelNo,
            activity_id: actInfo.id,
            material_ids: [actInfo.webPageId],
            activity_label: '转介绍'
          });
        }
      })
      .catch(() => {
        // 查询失败静默降级：不弹窗，不影响活动页正常展示
      });
  }, [pageData.loading, actInfo.id, actInfo.activityType]);

  // 推荐礼弹窗主按钮：跳转接口返回的 linkUrl（先关弹窗防重复点击）
  const handleGiftModalAction = () => {
    if (!giftGuidanceData?.linkUrl) {
      return;
    }
    sensClickInitiative({
      $element_name: '运营活动活动页_领推荐礼弹窗点击',
      $element_content: '去领取',
      activity_id: actInfo.id,
      activity_label: '转介绍',
      material_ids: [actInfo.webPageId]
    });
    setGiftModalVisible(false);
    sessionStorage.setItem(CALLBACK_URL, encodeURIComponent(window.location.href));
    window.location.href = giftGuidanceData.linkUrl;
  };

  const handleGiftModalClose = () => {
    sensClickInitiative({
      $element_name: '运营活动活动页_领推荐礼弹窗点击',
      $element_content: '下次再说',
      activity_label: '转介绍',
      activity_id: actInfo.id,
      material_ids: [actInfo.webPageId]
    });
    setGiftModalVisible(false);
  };

  const { components, posterSharingButtonIndex } = pageData;

  // 从前活动页跳转至该页面记录用户浏览行为
  const saveUserVisit = (daylate: string | number, needToast: boolean) => {
    const { slug = [] } = (router.query as any) || {};
    const numberDuration = typeof daylate === 'number' ? daylate : parseInt(daylate, 10);
    if (slug.length < 2) {
      return;
    }
    const actCode = slug[1];
    const qs = qsParse();
    const actCodeQuery = {
      actCode,
      inviteCode: qs.invite || '',
      channel: channelStr,
      teamId: shareId,
      isSaveVisitAction: true
    };
    timerRef.current = setTimeout(async () => {
      try {
        await getByActCode<ActInfo>(actCodeQuery, true)
          .then((res) => {
            if (res.code === 'SUCCESS' && res.data) {
              if (needToast) {
                Toast.success('您已完成浏览任务');
              }
              if (timerRef.current) clearTimeout(timerRef.current);
            }
          })
          .catch(() => {
            Toast.fail('网络错误，请稍后再试');
            if (timerRef.current) clearTimeout(timerRef.current);
          });
      } catch (error) {
        Toast.fail('网络错误，请稍后再试');
        if (timerRef.current) clearTimeout(timerRef.current);
      }
    }, numberDuration || 10000);
  };

  const getLotteryCount = async () => {
    const { activityType, webPageId, actCode } = actInfo;
    if (['LOTTERY', 'GENERAL_TASK_ACTIVITY'].includes(activityType) && webPageId && actCode) {
      const _t = Date.now();
      const actCodeQuery = {
        webPageId,
        teacherId,
        activityCode: actCode,
        _t
      };
      await queryPackageWebPage(actCodeQuery).then((res) => {
        if (res.code === 'SUCCESS') {
          const { data } = res;
          const { components: showList } = pageData;
          const list = JSON.parse(JSON.stringify(showList));
          if (Array.isArray(data) && data.length > 0) {
            list.splice(0, data.length, ...data);
          }
          setPageData((ct) => {
            return {
              ...ct,
              components: list
            };
          });
        }
      });
    }
  };

  const refreshComponents = async () => {
    const { webPageId, actCode } = actInfo;
    if (webPageId && actCode) {
      const _t = Date.now();
      const actCodeQuery = {
        webPageId,
        teacherId,
        activityCode: actCode,
        _t
      };
      await queryPackageWebPage(actCodeQuery).then((res) => {
        if (res.code === 'SUCCESS') {
          const { data } = res;
          const { components: showList } = pageData;
          const list = JSON.parse(JSON.stringify(showList));
          if (Array.isArray(data) && data.length > 0) {
            list.splice(0, data.length, ...data);
          }
          setPageData((ct) => {
            return {
              ...ct,
              components: list
            };
          });
        }
      });
    }
  };

  useEffect(() => {
    if (['CURRENT_ACTIVITY', 'ALL'].includes(pageData?.recordUserVisitTask || '')) {
      saveUserVisit(pageData.userVisitDuration || 10000, false);
    } else if (needSaveVisit && duration) {
      saveUserVisit(duration, true);
    }
  }, [needSaveVisit, duration, pageData.recordUserVisitTask, pageData.userVisitDuration]);
  // 商城店铺、海报
  const isActClose = !['PROCESSING'].includes(actInfo.activityStatus);
  const isClose = !actInfo.includedCurrentUser || isActClose;

  // 海报页跳转地址
  const posterUrl = useMemo(() => {
    const { slug = [] } = (router.query as any) || {};
    return `/activity/poster/${slug[0]}?actId=${actInfo.id}&actCode=${actInfo.actCode}&channel=${
      channelStr || ''
    }&channelNo=${channelNo || ''}`;
  }, [actInfo.actCode, actInfo.id, channelStr, channelNo, router.query]);

  // 家长端小程序原生海报页地址
  const MiniProgromJumpUrl = useMemo(() => {
    return `${WX_JOJO_PARENTS_POSTER_PAGE}?actId=${actInfo.id}&actCode=${actInfo.actCode}&channel=${
      channelStr || ''
    }&channelNo=${channelNo || ''}`;
  }, [channelStr, channelNo, actInfo.actCode, actInfo.id]);

  const fastTeam: TourDetailType = useMemo(() => {
    const item = (components || []).find(({ componentType }) => {
      return componentType === 'TOUR';
    });

    if (shareId) {
      const tourDetail = item?.groupBookingJoinDetail?.find(({ groupBookId }: TourDetailType) => {
        return groupBookId === shareId;
      });
      return pageData.invite || tourDetail || null;
    } else {
      const tourDetail =
        item?.groupBookingJoinDetail?.sort((a: TourDetailType, b: TourDetailType) => {
          return Number(a.lastCount) - Number(b.lastCount);
        }) || [];

      if (tourDetail.length) {
        return tourDetail[0];
      } else {
        return null;
      }
    }
  }, [components, pageData.invite, shareId]);

  const isActPass = isClose && isBrowser && !pageData.loading;

  // 续费转介绍活动：未开始/已结束不整页拦截，改为可关闭弹窗提示
  const isRenewalReferral = isRenewalReferralActivity(actInfo.activityType, actInfo.sceneLabel);

  // 风险用户，展示无商品
  const isNoGoods = actInfo.riskUser === 'RISK_USER';

  const isInviteFriends = actInfo.activityType === 'INVITE_FRIENDS_TO_WIN';

  if (pageData.loading && query.pScene !== '1') {
    return <PageLoading />;
  }

  // 非资格用户，排除抽奖活动
  if (!actInfo.includedCurrentUser && !['LOTTERY'].includes(pageData.actInfo.activityType)) {
    return (
      <>
        <Abnormal type={2} />
        <SignModal
          sensData={{
            channel: qsParse().channel,
            channelNo: qsParse().channelNo,
            activity_id: actInfo.id,
            activity_label: sensInfo.sceneLabel,
            material_ids: [actInfo.webPageId.toString()]
          }}
          phone={actInfo.userHalfMobile}
          nickname={actInfo.userNickname}
          avatar={actInfo.userAvatar}
          userId={actInfo.userId}
          show
        />
      </>
    );
  }

  // 活动异常， 排除抽奖活动、续费转介绍活动
  if (
    isActPass &&
    !['RESERVE', 'GROUP', 'LOTTERY', 'GENERAL_TASK_ACTIVITY'].includes(
      pageData.actInfo.activityType
    ) &&
    !isRenewalReferral
  ) {
    const text: Record<string, string> = {
      PENDING: '活动未开始'
    };
    return <Abnormal type={2} defaultText={text[actInfo.activityStatus] || '活动已结束'} />;
  }
  //  弹窗显示逻辑， 活动状态pass， 并且不是['RESERVE', 'GROUP', 'LOTTERY']其中的活动类型
  //  但是，抽奖活动，有单独的现实逻辑，弹窗可根据操作showTipsPopup显示

  // 可关闭弹窗（我知道了）的活动：抽奖、通用任务、续费转介绍
  const isClosableTips =
    ['LOTTERY', 'GENERAL_TASK_ACTIVITY'].includes(pageData.actInfo.activityType) ||
    isRenewalReferral;

  const tipsPopupVisible =
    (isActPass &&
      !['RESERVE', 'GROUP', 'LOTTERY', 'GENERAL_TASK_ACTIVITY'].includes(
        pageData.actInfo.activityType
      ) &&
      !isRenewalReferral) ||
    showTipsPopup;

  // 弹窗按钮文案：续费转介绍「我知道了」，抽奖/通用任务「我知道啦」，其他「立即前往」
  let tipsBtnText = '立即前往';
  if (isRenewalReferral) {
    tipsBtnText = '我知道了';
  } else if (isClosableTips) {
    tipsBtnText = '我知道啦';
  }

  // 弹窗内容：续费转介绍仅展示状态文案，抽奖/通用任务、其他活动保持原样
  const renderTipsContent = () => {
    if (isRenewalReferral) {
      return <div style={{ textAlign: 'center' }}>{getStatusTipsText(actInfo.activityStatus)}</div>;
    }
    // 抽奖活动没有继续参与
    if (['LOTTERY', 'GENERAL_TASK_ACTIVITY'].includes(pageData.actInfo.activityType)) {
      return (
        <div style={{ textAlign: 'center' }}>
          {!actInfo.includedCurrentUser
            ? '活动暂未对您开放'
            : `当前活动${actInfo.activityStatus === 'PENDING' ? '未开始' : '已结束'}`}
        </div>
      );
    }
    return (
      <>
        当前活动{actInfo.activityStatus === 'PENDING' ? '未开始' : '已结束'}
        ，点击按钮前往参与最新活动吧！
      </>
    );
  };

  return (
    <>
      <Head>
        <title>{pageData.actInfo.activityName}</title>
      </Head>
      <Guidance {...actInfo.noviceGuidanceInfo} visible={actInfo.showNoviceGuidance} />
      {/* 页面内异常提醒，抽奖/续费转介绍走state状态判断, 并且可以点击关闭按钮 */}
      <TipsPopup
        visible={tipsPopupVisible}
        btnText={tipsBtnText}
        onClose={
          isClosableTips
            ? () => {
                // 抽奖/续费转介绍活动可以关闭提示
                setShowTipsPopup(false);
              }
            : null
        }
        onConfirm={() => {
          // 抽奖/续费转介绍活动可以关闭提示
          if (isClosableTips) {
            setShowTipsPopup(false);

            return;
          }

          const { defaultActivityUrl } = actInfo;
          if (defaultActivityUrl) {
            window.location.href = defaultActivityUrl;
          } else {
            Toast.info('没有更多活动了');
          }
        }}>
        {renderTipsContent()}
      </TipsPopup>
      <main className={styles.main} id={'activity-page'}>
        <PageProcess />
        {maskPageLoading ? (
          <div className={styles.maskPageLoading}>
            <PageLoading />
          </div>
        ) : null}
        {components?.map((item: any, index: number) => {
          const {
            componentType,
            componentId,
            commonExtVo = {},
            descriptions = [],
            context,
            shopVo = {},
            shopProductVos = [],
            isReloadMain = false,
            moduleImageExtVo,
            inviteProgessData = [{}],
            newStyle = [],
            sortNum,
            groupBookingJoinDetail,
            endDate = '0',
            startDate = '0',
            minGroupPrice = '',
            maxOriginalPrice = '',
            productId = '',
            backImage,
            content,
            screenshotResult,
            style,
            needCheckFlag,
            updateCycleType,
            showTimeFlag,
            showEndTime,
            showStartTime,
            countdownModel,
            limitHour,
            dataScope,
            delayTime,
            delaySum,
            delayText,
            expirationTime,
            expirationSum,
            dynamicData,
            headerImage,
            showType,
            // 积分兑换余额
            tokenBalance
            // isCanJoinGroup,
            // minGroupPrice = '0',
          } = item || {};

          const { material_ids, activity_label, material_type, activity_id } = sensInfo;

          const key = `${componentId}_${index}`;
          const actId = actInfo.id;

          switch (componentType) {
            case 'USER_LOGIN_INFO': {
              return (
                <ChangeUser
                  style={commonExtVo.style}
                  key={key}
                  userNickname={actInfo.userNickname}
                  userAvatar={actInfo.userAvatar}
                  userId={actInfo.userId}
                  userHalfMobile={actInfo.userHalfMobile}
                  sensData={{
                    $element_id: componentId,
                    activity_label,
                    material_ids,
                    material_type,
                    activity_id
                  }}
                />
              );
            }
            case 'VIDEO': {
              return <VideoCom key={key} {...commonExtVo} />;
            }
            case 'MODULE_IMAGE': {
              return (
                <ImageGroup
                  activityType={actInfo.activityType}
                  invite={noPublicInvite}
                  items={moduleImageExtVo.moduleData}
                  presentationStyle={moduleImageExtVo.presentationStyle}
                  key={key}
                />
              );
            }
            case 'COUNT_DOWN': {
              const endTime =
                countdownModel === 'HOURS'
                  ? Math.floor(
                      new Date(
                        new Date(new Date().getTime() + 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
                      ).getTime() / 1000
                    )
                  : Math.round(actInfo.endTime / 1000);

              return (
                <Timer
                  key={key}
                  backImage={commonExtVo.backImage}
                  content='距离活动结束'
                  endTime={endTime}
                />
              );
            }
            // POSTER_GROUP
            case 'POSTER_GROUP': {
              return (
                <PosterCom
                  key={key}
                  webPageId={actInfo.webPageId}
                  activityType={actInfo.activityType}
                  posterFlowGrayscale={actInfo.posterFlowGrayscale}
                  actCode={actInfo.actCode}
                  activityId={actInfo.id}
                  posters={actInfo.posters}
                  guideShareText={actInfo.guideShareText}
                  {...commonExtVo}
                />
              );
            }
            case 'CLOCK_IN': {
              return <SignIn key={key} activityId={actId} {...(item || {})} />;
            }
            case 'WEEKLY_ACTIVITY_DETAIL': {
              return (
                <ImgComp
                  key={key}
                  onSensors={() => {
                    sensClickInitiative({
                      $element_name: '运营活动活动页_组件点击',
                      $element_id: componentId,
                      $element_type: '周周活动明细',
                      $element_class_name: '1',
                      activity_label,
                      material_ids,
                      material_type,
                      activity_id
                    });
                  }}
                  src={commonExtVo.backImage}
                  href={`/activity/shareList?actCode=${actInfo.actCode}&webPageId=${actInfo.webPageId}`}
                />
              );
            }
            // 上传图片
            case 'SCREEN_SHOT': {
              if (!screenshotResult) {
                return null;
              }

              const {
                // 用户是否有权限上传
                isSuccess,
                message,
                operateType,
                url,
                hasShared,
                canUploadTime,
                // 上传成功后是否需要填写地址
                uploadScreenshotNeedShip
              } = screenshotResult;

              // 审核未通过operateType
              // 用户是否还可以上传
              const statusMap: any = {
                NONE: 0,
                WAIT: 1,
                SUCCESS: 2,
                FAIL: 3,
                UPLOAD_AGAIN: 3,
                ACTIVITY_END: 4,
                NEXT_WEEK: 5
              };

              let status = statusMap[operateType] || 0;
              status = url ? status : 0;

              const btnData =
                components[
                  posterSharingButtonIndex === undefined ? -1 : posterSharingButtonIndex
                ] || {};
              const posterjumpUrl =
                isParentTerminalMiniProgram() &&
                pageData.isNeedJumpToMiniProgram &&
                !pageData.hasPosterComponent
                  ? MiniProgromJumpUrl
                  : posterUrl;

              const uProps = {
                isSuccess,
                message,
                operateType,
                url,
                defaultUrl: content,
                defaultStatus: status,
                backImage,
                needCheckFlag,
                updateCycleType,
                height: `${style.height / 100 || 3.6}rem`,
                hasShared,
                showTimeFlag,
                showEndTime,
                showStartTime,
                canUploadTime,
                btnStyle: btnData?.commonExtVo?.style,
                posterUrl: posterjumpUrl,
                isInParentWxMiniProgram:
                  isParentTerminalMiniProgram() &&
                  pageData.isNeedJumpToMiniProgram &&
                  !pageData.hasPosterComponent,
                limitHour,
                headerImage,
                showType,
                // 仅在此处（[...slug].tsx）传递该字段，其他地方引用 Upload 组件时不受影响
                // 兼容 null / undefined / 0 / '' / false 等边界值，统一转为 boolean
                needAddressAfterUpload:
                  uploadScreenshotNeedShip === true || uploadScreenshotNeedShip === 1
              };

              // 检查是否点击过 GENERATE_POSTER 按钮
              const isPosterShareClicked = (() => {
                try {
                  const list = JSON.parse(localStorage.getItem('posterShareClickList') || '[]');
                  return Array.isArray(list) && list.includes(actInfo.id);
                } catch {
                  return false;
                }
              })();

              return (
                <Upload
                  key={key}
                  {...uProps}
                  actId={actInfo.id}
                  showSharedTip={isPosterShareClicked}
                />
              );
            }
            // 开团
            case 'COLLAGE': {
              // const { isOrderNeedPhone } = commonExtVo
              const sd = Number(startDate);
              const ed = Number(endDate);
              const price = Number(minGroupPrice);
              const oPrice = Number(maxOriginalPrice);
              const teamStatus = getTeamStatus(sd, ed);

              // userIsCanJoinGroup = isCanJoinGroup

              const tProps = {
                activityCode: actInfo.actCode,
                startDate: sd,
                endDate: ed,
                fastTeam,
                minGroupPrice: price,
                // miniOriginalPrice: oPrice,
                maxOriginalPrice: oPrice,
                teamStatus,
                activityId: actId,
                productId,
                componentId,
                isCanJoinGroup: userIsCanJoinGroup,
                isNoGoods,
                groupBookingJoinDetail
              };

              return shareId ? (
                <TeamPanelShare invite={pageData.invite} key={key} {...tProps} />
              ) : (
                <TeamPanel key={key} {...tProps} />
              );
            }
            // 参团
            case 'TOUR': {
              const isHide = fastTeam && !fastTeam?.collageLimitIncludedCurrentUser;

              return shareId || isNoGoods || isHide ? null : (
                <TeamList
                  activityCode={actInfo.actCode}
                  key={key}
                  componentId={componentId}
                  backImage={commonExtVo.backImage}
                  activityId={actId}
                  isCanJoinGroup={userIsCanJoinGroup}
                  tourDetail={groupBookingJoinDetail}
                />
              );
            }
            // 浮标
            case 'BUOY': {
              const {
                backImage: bg,
                style: sty,
                reloadType,
                positionFixed,
                content: href
              } = commonExtVo;

              return (
                <Buoy
                  href={href}
                  key={key}
                  actId={actId}
                  style={sty}
                  positionFixed={positionFixed}
                  sortNum={sortNum}
                  webPageId={actInfo.webPageId}
                  actCode={actInfo.actCode}
                  img={bg}
                  reloadType={reloadType}
                  noviceStatus={Boolean(actInfo.noviceGuidanceInfo)}
                />
              );
            }
            // 邀请进度
            case 'INVITE_PROGRESS': {
              return (
                <InvitedProgress
                  key={key}
                  backgroundImage={commonExtVo.backImage}
                  newStyle={newStyle}
                  inviteProgessData={inviteProgessData[0]}
                  channel={channelStr}
                  channelNo={channelNo}
                  dataScope={dataScope}
                />
              );
            }
            // 完课进度
            case 'COURSE_COMPLETION_PROGRESS': {
              const {
                backImage: courseBackImage,
                lessonCount,
                actualLessonCount,
                shortName,
                amount
              } = commonExtVo;
              return (
                <CourseCompletionProgress
                  key={key}
                  backImage={courseBackImage}
                  lessonCount={lessonCount}
                  actualLessonCount={actualLessonCount}
                  shortName={shortName || ''}
                  amount={amount}
                />
              );
            }
            // 配图
            case 'FIGURE_CAPTIONS': {
              return (
                <ImgComp
                  onSensors={() => {
                    sensClickInitiative({
                      $element_name: '运营活动活动页_组件点击',
                      $element_id: componentId,
                      $element_type: '图片',
                      $element_class_name: '1',
                      activity_label,
                      material_ids,
                      material_type,
                      activity_id
                    });
                  }}
                  key={key}
                  src={commonExtVo.backImage}
                  href={commonExtVo.reloadUrl}
                />
              );
            }
            // 任务
            case 'TASK': {
              return (
                <TasksComp
                  key={key}
                  item={item}
                  posterUrl={posterUrl}
                  jumpMiniProgram={isParentTerminalMiniProgram()}
                  miniJumpUrl={MiniProgromJumpUrl}
                  isNeedJumpToMiniProgram={pageData.isNeedJumpToMiniProgram}
                  userVisitDuration={pageData?.userVisitDuration}
                  isActPass={isActPass}
                  onActPassClick={() => {
                    setShowTipsPopup(true);
                  }}
                  recordUserVisitTask={['OTHER_ACTIVITIES', 'ALL'].includes(
                    pageData?.recordUserVisitTask || ''
                  )}
                />
              );
            }
            // 走马灯
            case 'RUNNING_LANTERN': {
              const customize = context.length > 1;
              const renderItems = customize ? context : namesArr;
              const { backImage: bg, style: sty } = commonExtVo || {};

              if (sty === 'MULTI_LINE_SCROLLING') {
                return (
                  <Swiper
                    style={{
                      height: `${((context.length - 1) * 40) / 100}rem`,
                      backgroundImage: `url(${bg})`
                    }}
                    multi
                    key={key}
                    className={styles['swiper-multi']}>
                    {renderItems.map((name: string, idx: number) => {
                      const innerKey = `${name}_${idx}`;
                      return (
                        <div key={innerKey} className={cx(styles.item, 'fn-cut')}>
                          {name}
                        </div>
                      );
                    })}
                  </Swiper>
                );
              }

              return (
                <Swiper multi={false} key={key} className={styles.swiper}>
                  {renderItems.map((name: string, idx: number) => {
                    const innerKey = `${name}_${idx}`;
                    return (
                      <div key={innerKey} className={styles.item}>
                        <i className={cx('ui-icon', 'ui-icon__sound')} />
                        {customize ? (
                          <span className={cx(styles.txt, 'fn-cut')}>{name}</span>
                        ) : (
                          <div className={cx(styles.desc, 'fn-cut')}>
                            <span>{name}</span>
                            {context[0]}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </Swiper>
              );
            }
            case 'INVITE_DETAIL': {
              return (
                <ImgComp
                  key={key}
                  src={commonExtVo.backImage}
                  href={`/activity/details?${QS.stringify({
                    inviteDetail: item.inviteDetail,
                    activityId: actInfo.id,
                    activityType: actInfo.activityType,
                    channel: channelStr,
                    channelNo,
                    actCode: actInfo.actCode
                  })}`}
                  onSensors={() => {
                    sensClickInitiative({
                      $element_name: '运营活动活动页_组件点击',
                      $element_id: componentId,
                      $element_type: '邀请明细',
                      $element_class_name: '1',
                      activity_label,
                      material_ids,
                      material_type,
                      activity_id
                    });
                  }}
                />
              );
            }
            // 商城店铺
            case 'MALL_STORE': {
              return (
                <ShopModule
                  key={key}
                  jumpShop={isReloadMain}
                  shopUrl={shopVo.shopUrl}
                  products={shopProductVos}
                  componentId={componentId}
                  background={commonExtVo.backImage}
                  tokenBalance={tokenBalance}
                  shopVo={shopVo}
                />
              );
            }
            // 推荐礼专区
            case 'RECOMMEND_GIFT': {
              return (
                <RecommendGift
                  key={key}
                  commonExtVo={commonExtVo}
                  componentId={componentId}
                  prizePoolId={item?.prizePoolId || 0}
                  background={commonExtVo.backImage}
                  displayProps={item?.displayProps || []}
                  data={dynamicData}
                  inviteUrl={`${dynamicData.myInviteDetailUrl}&${QS.stringify({
                    activityType: actInfo.activityType,
                    channel: channelStr,
                    channelNo
                  })}`}
                  receiveUrl={`${dynamicData.myReceiveRecordUrl}&${QS.stringify({
                    activityType: actInfo.activityType,
                    channel: channelStr,
                    channelNo
                  })}`}
                />
              );
            }
            case 'BUTTON': {
              const { reloadType, isBottom, style: sty, canShare } = commonExtVo;

              // 续费转介绍分享按钮过期文案与其他按钮区分
              const canShareToastText = getCanShareToastText(reloadType);

              const canShareGuard = (e: React.MouseEvent) => {
                if (canShare === false) {
                  e.stopPropagation();
                  e.preventDefault();
                  Toast.info(canShareToastText);
                }
              };

              const canShareWrapper = (children: React.ReactNode) => (
                <div onClickCapture={canShareGuard}>{children}</div>
              );

              if (reloadType === 'INVITE_FRIENDS_TO_WIN') {
                return canShareWrapper(
                  <InviteFriendsV2
                    key={key}
                    componentId={componentId}
                    data={commonExtVo}
                    actId={activity_id}
                  />
                );
              }

              if (reloadType === 'USER_POINT_LOTTERY') {
                return canShareWrapper(
                  <PointLotteryBtn
                    key={key}
                    data={commonExtVo}
                    actId={activity_id}
                    isBottom={isBottom}
                    isActPass={isActPass}
                    setShowTipsPopup={setShowTipsPopup}
                    onClick={(state = 1) => {
                      sensClickInitiative({
                        $element_name: '运营活动活动页_组件点击',
                        $element_id: componentId,
                        $element_type: '按钮',
                        $element_class_name: '9',
                        activity_label,
                        material_ids,
                        material_type,
                        activity_id,
                        topic_name: labelName(actInfo.sceneLabel),
                        custom_state: state
                      });
                    }}
                  />
                );
              }
              if (reloadType === 'SIGN_UP') {
                return canShareWrapper(
                  <SignButton
                    key={key}
                    data={commonExtVo}
                    activityId={actId}
                    sensInfo={{
                      $element_id: componentId?.toString(),
                      activity_id: actId,
                      material_ids,
                      activity_label
                    }}
                    onSuccess={refreshComponents}
                    onClick={() => {
                      sensClickInitiative({
                        $element_name: '运营活动活动页_组件点击',
                        $element_id: componentId,
                        $element_type: '按钮',
                        $element_class_name: '10',
                        $element_content: commonExtVo?.isRegistered ? '已报名' : '未报名',
                        material_ids,
                        material_type,
                        activity_id,
                        topic_name: labelName(actInfo.sceneLabel)
                      });
                    }}
                  />
                );
              }

              if (reloadType === 'GENERATE_POSTER_TRIAL_DIRECT') {
                return canShareWrapper(
                  <TrialDirectPosterButton
                    key={key}
                    isBottom={isBottom}
                    style={sty}
                    shareBtn1={sty.shareBtn1}
                    shareBtn2={sty.shareBtn2}
                    reloadType={reloadType}
                    posterUrl={posterUrl}
                    sensorInfo={{
                      $element_id: componentId?.toString(),
                      activity_id: actId,
                      material_ids,
                      activity_label
                    }}
                    onSensors={(i) => {
                      const posters = actInfo.posters || [];
                      if (Array.isArray(posters) && posters.length === 2) {
                        const type = posters[i].sceneType;
                        sensClickInitiative({
                          $element_name: '运营活动活动页_组件点击',
                          $element_id: componentId,
                          $element_type: '按钮',
                          $element_class_name: '14',
                          $element_content: type === 'SYSTEM_PACKAGE' ? '直购' : '体验',
                          activity_label,
                          material_ids,
                          material_type,
                          activity_id,
                          topic_name: labelName(actInfo.sceneLabel)
                        });
                      }
                    }}
                  />
                );
              }

              return reloadType === 'REFERRAL_UPLOAD'
                ? null
                : canShareWrapper(
                    <ButtonComp
                      key={key}
                      isBottom={isBottom}
                      style={sty}
                      src={commonExtVo.backImage}
                      reloadType={reloadType}
                      href={reloadType === 'GENERATE_POSTER' ? posterUrl : commonExtVo.bizData}
                      isNeedJumpToMiniProgram={pageData.isNeedJumpToMiniProgram}
                      onSensors={(e) => {
                        const typeMap: Record<string, string> = {
                          GENERATE_POSTER: '3',
                          H5: '1',
                          APP: '2',
                          SHARE_CONTROLS: '5',
                          LOTTERY: '6'
                        };

                        sensClickInitiative({
                          $element_name: '运营活动活动页_组件点击',
                          $element_id: componentId,
                          $element_type: '按钮',
                          $element_class_name: typeMap[reloadType] || '5',
                          activity_label,
                          material_ids,
                          material_type,
                          activity_id,
                          topic_name: labelName(actInfo.sceneLabel)
                        });
                        if (['LOTTERY'].includes(reloadType)) {
                          e?.preventDefault();
                          e?.stopPropagation();
                          // 活动未开始/已结束/用户非生效用户，提示用户
                          if (isActPass) {
                            setShowTipsPopup(true);
                            return;
                          }

                          bus.emit('lottery-open', { a: true });
                        } else if (reloadType === 'SHARE_CONTROLS' && isInviteFriends) {
                          // 邀请关注公众号流程
                          e?.preventDefault();
                          ButtonShareRef.current.change(isWx ? 7 : 1);
                        } else if (reloadType === 'GENERATE_POSTER') {
                          if (
                            isParentTerminalMiniProgram() &&
                            pageData.isNeedJumpToMiniProgram &&
                            !pageData.hasPosterComponent
                          ) {
                            wx.miniProgram.navigateTo({
                              url: MiniProgromJumpUrl
                            });
                            return;
                          }
                          if (
                            components.findIndex((it) => it.componentType === 'POSTER_GROUP') >= 0
                          ) {
                            e?.preventDefault();
                            e?.stopPropagation();

                            const $poster = document.getElementById('j-poster') as HTMLDivElement;

                            window.scrollTo(0, (offset($poster)?.top || 0) + 300);
                          }

                          userActionRecord({
                            actionType: '点击',
                            actionContent: '跳转按钮',
                            data: {
                              activityId: actInfo.id,
                              channel: channelStr,
                              channelNo
                            },
                            url: window.location.href,
                            userType: 'INITIATIVE',
                            sceneType: actInfo.activityType
                          });

                          // 记录 GENERATE_POSTER 点击到 localStorage
                          try {
                            const posterShareClickList = JSON.parse(
                              localStorage.getItem('posterShareClickList') || '[]'
                            );
                            const targetClick = actInfo.id;
                            if (Array.isArray(posterShareClickList)) {
                              if (!posterShareClickList.includes(targetClick)) {
                                posterShareClickList.push(targetClick);
                                localStorage.setItem(
                                  'posterShareClickList',
                                  JSON.stringify(posterShareClickList)
                                );
                              }
                            } else {
                              posterShareClickList.push(targetClick);
                              localStorage.setItem(
                                'posterShareClickList',
                                JSON.stringify(posterShareClickList)
                              );
                            }
                          } catch (err) {
                            // ignore localStorage errors
                          }
                        } else if (reloadType === 'MINI_PROGRESS') {
                          if (e && e.preventDefault) {
                            e.stopPropagation();
                            e.preventDefault();
                          }
                          openLinkByMiniWay({
                            miniAppJumpUrl: commonExtVo?.miniAppJumpUrl,
                            miniAppId: commonExtVo?.miniAppId
                          });
                        } else if (reloadType === 'APP' && isWXMiniAppBrowser()) {
                          e?.preventDefault();
                          e?.stopPropagation();
                          Toast.info('请打开APP参与');
                        }
                      }}
                    />
                  );
            }
            case 'LOTTERY': {
              return (
                <LotteryBox
                  limitText={actInfo.limitText}
                  activityId={actId}
                  limitButtonText={actInfo.limitButtonText}
                  limitRedirectUrl={actInfo.limitRedirectUrl}
                  {...commonExtVo}
                  getLotteryCount={getLotteryCount}
                  key={key}
                />
              );
            }
            case 'RESERVE': {
              const {
                actInfo: { id, actCode, userHalfMobile },
                components: cmps,
                reserve
              } = pageData;
              const reserveComp = cmps?.filter((comp) => comp.componentType === 'RESERVE')[0];
              if (!reserve) {
                return null;
              }

              const {
                openTime,
                startTime,
                userReserved,
                reservePerson,
                userReservedJumpUrl,
                goodsSaleEndTime,
                endTime,
                teacherId: reserveTeacherId,
                productId: pId,
                whiteListUser,
                classPeriod,
                teacherNickName
              }: ReserveType = reserve;

              const { commonExtVo: cev } = reserveComp || {};
              const {
                buttonText: commonExtVoButtonText,
                accessButtonStyle,
                isShowPerson,
                jumpLink,
                jumpLinkType,
                firstClickVo,
                miniAppId,
                saleText
              } = cev ?? {};
              const buttonText = commonExtVoButtonText || '预约';
              return (
                <ReserveButton
                  whiteListUser={whiteListUser}
                  classPeriod={classPeriod}
                  phone={userHalfMobile}
                  teacherNickName={teacherNickName}
                  userReservedJumpUrl={userReservedJumpUrl}
                  key={key}
                  reservePerson={reservePerson}
                  buttonText={buttonText}
                  accessButtonStyle={accessButtonStyle}
                  isShowPerson={isShowPerson}
                  jumpLink={jumpLink}
                  jumpLinkType={jumpLinkType}
                  saleTime={openTime ?? endTime}
                  openTime={openTime}
                  componentId={componentId}
                  reserved={userReserved}
                  startTime={startTime}
                  saleText={saleText}
                  actId={id}
                  actCode={actCode}
                  productId={pId}
                  goodsSaleEndTime={goodsSaleEndTime}
                  firstClickVo={firstClickVo}
                  miniAppId={miniAppId}
                  material_ids={sensInfo.material_ids}
                  activity_label
                  reserveTeacherId={reserveTeacherId}
                />
              );
            }
            case 'LOTTERY_COUNT': {
              return (
                <LotteryCount
                  restCount={item?.restCount}
                  timesOfDrawn={item?.timesOfDrawn}
                  backImage={commonExtVo?.backImage}
                  showData={commonExtVo?.showData}
                  fontColor={commonExtVo?.color}
                  obtainLotteryCountText={actInfo?.obtainLotteryCountText}
                />
              );
            }
            case 'POINT_COMPONENT': {
              return <PointCom {...commonExtVo} count={item?.totalUserPoint} />;
            }
            case 'POINT_EXPIRE_COMPONENT': {
              return (
                <PointExpireComponent
                  delaySum={delaySum}
                  delayText={delayText}
                  expirationTime={expirationTime}
                  expirationSum={expirationSum}
                  delayTime={delayTime}
                  backImage={commonExtVo?.backImage || ''}
                  key={key}
                />
              );
            }
            case 'CAROUSEL': {
              return <Carousel key={key} {...commonExtVo} />;
            }
            case 'RESERVE_TIME': {
              const {
                actInfo: { id },
                components: cmps,
                reserve
              } = pageData;
              const reserveComp = cmps?.filter((comp) => comp.componentType === 'RESERVE')[0];
              if (!reserve) {
                return null;
              }

              const {
                openTime,
                startTime,
                userReserved,
                reservePerson,
                userReservedJumpUrl,
                goodsSaleEndTime,
                endTime,
                teacherId: reserveTeacherId,
                productId: pId
              }: ReserveType = reserve;

              const { commonExtVo: cev } = reserveComp || {};
              const {
                buttonText: commonExtVoButtonText,
                accessButtonStyle,
                jumpLink,
                jumpLinkType,
                firstClickVo,
                miniAppId,
                saleText
              } = cev ?? {};
              const buttonText = commonExtVoButtonText || '预约';

              return (
                <ReserveTime
                  userReservedJumpUrl={userReservedJumpUrl}
                  key={key}
                  reservePerson={reservePerson}
                  buttonText={buttonText}
                  accessButtonStyle={accessButtonStyle}
                  jumpLink={jumpLink}
                  jumpLinkType={jumpLinkType}
                  saleTime={openTime ?? endTime}
                  openTime={openTime}
                  componentId={componentId}
                  reserved={userReserved}
                  startTime={startTime}
                  saleText={saleText}
                  actId={id}
                  productId={pId}
                  goodsSaleEndTime={goodsSaleEndTime}
                  firstClickVo={firstClickVo}
                  miniAppId={miniAppId}
                  material_ids={sensInfo.material_ids}
                  activity_label
                  reserveTeacherId={reserveTeacherId}
                />
              );
            }
            case 'DESCRIPTION_POPUP': {
              return <DescriptionPopup key={key} descriptions={descriptions} />;
            }
            default:
              return null;
          }
        })}
        {isInviteFriends ? (
          <InviteFriends
            onRef={ButtonShareRef}
            invite={noPublicInvite}
            channel={channelStr}
            channelNo={channelNo}
            activityId={actInfo.id}
            actCode={actInfo.actCode}
            webPageId={actInfo.webPageId}
            configs={actInfo.activityGuideFlowConfigs}
            share={actInfo.shareInfo}
            teams={actInfo.teams}
            jumpAppActUrl={actInfo.jumpAppActUrl}
            sharePostImg={actInfo.shareInfo.sharePostImg}
            sceneLabel={actInfo.sceneLabel}
            banduNewUser={actInfo.banduNewUser}
            banduYearCourseUser={actInfo.banduYearCourseUser}
            userInfo={{
              noCourse: actInfo.noCourse,
              parentAvatar: actInfo.parentAvatar,
              parentNickname: actInfo.parentNickname,
              avatar: actInfo.avatar,
              nickname: actInfo.nickname,
              prizeUserCount: actInfo.prizeUserCount,
              prizeMaxLimit: actInfo.prizeMaxLimit,
              shared: actInfo.shared
            }}
            components={pageData.components}
          />
        ) : null}
        {isInviteFriends || bottomStatus.current ? (
          <div id='j-mbottom' className={styles.mbottom} />
        ) : null}
      </main>
      {retainRuleData ? (
        <AppDialog
          // H5跳原生场景，小程序端不显示挽留弹窗，问题较多，待排除解决
          needGuard={!(isParentTerminalMiniProgram() && pageData.isNeedJumpToMiniProgram)}
          data={retainRuleData}
          onVisibleChange={(visible: boolean) => {
            if (visible) {
              sensElementView({
                c_element_name: '运营活动活动页_挽留 弹窗曝光',
                material_type: retainRuleData.id,
                activity_label: '转介绍',
                activity_id: retainRuleData.activityId,
                material_ids: retainRuleData.material_ids
              });
            }
          }}
          onOptionSelected={async (selected: boolean, text: string) => {
            if (selected) {
              try {
                const env = await getEnvEnum();
                sensClickInitiative({
                  $element_name: '运营活动活动页_挽留弹窗内容按钮点击',
                  $element_content: text,
                  activity_label: '转介绍',
                  custom_platform: platformList[env] || '其他',
                  material_type: retainRuleData.id,
                  activity_id: retainRuleData.activityId,
                  material_ids: retainRuleData.material_ids
                });
              } catch (e) {
                console.log(e);
              }
            }
          }}
          onButtonClicked={async (text: string) => {
            try {
              const env = await getEnvEnum();
              sensClickInitiative({
                $element_name: '运营活动活动页_挽留弹窗底部按钮点击',
                $element_content: text,
                activity_label: '转介绍',
                custom_platform: platformList[env] || '其他',
                material_type: retainRuleData.id,
                activity_id: retainRuleData.activityId,
                material_ids: retainRuleData.material_ids
              });
            } catch (error) {
              console.log(error);
            }
          }}
        />
      ) : null}
      {/* 推荐礼待领奖弹窗 - 仅 xuedou 场景且有待领奖励时展示 */}
      {giftModalVisible && isBrowser
        ? createPortal(
            <div className={styles.giftGuidanceMask} onClick={handleGiftModalClose}>
              <div className={styles.giftGuidanceDrawer} onClick={(e) => e.stopPropagation()}>
                <div className={styles.giftGuidanceHeader}>
                  <img src={GiftIcon} alt='' className={styles.giftGuidanceIcon} />
                </div>
                <div className={styles.giftGuidanceTitle}>{giftGuidanceData?.tipsText || ''}</div>
                <div className={styles.giftGuidanceBtn} onClick={handleGiftModalAction}>
                  去领取
                </div>
                <div className={styles.giftGuidanceClose} onClick={handleGiftModalClose}>
                  暂不领取
                </div>
              </div>
            </div>,
            document.body
          )
        : null}
      <UserFeedback visible={actInfo.showScore} />
    </>
  );
});

export default ActivityPage;
